/**
 * Global Imports
*/

import React, { Fragment, useContext } from 'react';
import { Link } from 'react-router-dom';

/**
 * Root Imports
*/

import { CssClassName } from '~/util/Css';
import { Breadcrumbs } from '~/components/Widget/Breadcrumbs';
import { PageContext } from '~/components/PageProvider';

/**
 * Local Imports
*/

import { VerifiedRouter } from '../../Routers/Verified';

/**
 * Locals
*/

/**
 * 
 */
function Menu(props) {
  /** Contexts **/
  
  const page = useContext(PageContext);

  /** Renderers **/

  const renderChildren = () => (
    React.Children.map(props.children,
      child => {
        if (page.group !== child.props.group) {
          return child;
        } else {
          return React.cloneElement(child, { ...child.props, className: 'bg-indigo-800' });
        }
      }  
    )
  );

  /** Output **/

  return (
    <nav className='fixed flex flex-col w-56 h-full text-white bg-gray-800'>
      { renderChildren() }
    </nav>
  );
}

/**
 * 
 */
function MenuItem(props) {
  return (
    <Link
      to={ props.to }
      group={ props.group }
      className={
        CssClassName([
          'cursor-pointer flex p-4 hover:bg-indigo-700', props.className
        ])
      }
    >
      { props.name }
    </Link >
  );
}

/**
 * Exports
*/

/**
 * 
 */
export function VerifiedLayout(props) {
  /** Contexts **/
  
  const page = useContext(PageContext);

  /** Output **/
  
  return (
    <Fragment>
      <Menu>
        <MenuItem name='Dashboard' to='/' group='dashboard' />
        <MenuItem name='Users' to='/users' group='users' />
        <MenuItem name='Abilities' to='/abilities' group='abilities' />
        <MenuItem name='Roles' to='/roles' group='roles' />
        <MenuItem name='Permissions' to='/permissions' group='permissions' />
        <MenuItem name='Logout' to='/logout' group='logout' />
      </Menu>
      <div className='flex h-full ml-56 p-4 bg-gray-600'>
        <div className='flex-shrink w-full'>
          <Breadcrumbs>
            {
              Array.isArray(page.breadcrumbs)
                ? page.breadcrumbs.join(' / ')
                : page.breadcrumbs
            }
          </Breadcrumbs>
          <VerifiedRouter />
        </div>
      </div>
    </Fragment>
  );
}